<template>
  <v-autocomplete
    label="Município"
    :items="municipios"
    :loading="municLoading"
    item-text="descricao"
    item-value="codigo"
    no-data-text="Nenhum município encontrado"
    v-model="municSelecModel"
    :dense="dense"
    :disabled="disabled"
  ></v-autocomplete>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
export default {
  props: {
    dense: Boolean,
    disabled: Boolean
  },
  watch: {
    municSelec: async function () {
      this.setLocalidSelec(0);
      await this.getLocalidades();
    },
  },
  computed: {
    ...mapState("locais", ["municipios", "municSelec", "municLoading"]),
    municSelecModel: {
      get: function () {
        return this.municSelec;
      },
      set: function (value) {
        this.setMunicSelec(value);
      },
    },
  },  
  methods: {
    ...mapMutations("locais", ["setMunicSelec", "setLocalidSelec"]),
    ...mapActions("locais", ["getLocalidades"]),
  },  
};
</script>

<style>
</style>